import * as React from 'react';
import * as S from './area.styles';

export interface IBaseAreaProps extends Omit<React.PropsWithoutRef<JSX.IntrinsicElements['textarea']>, 'children'> {}

export class BaseArea extends React.Component<IBaseAreaProps> {
    public render(): React.ReactElement {
        return <S.AreaContainer {...this.props}></S.AreaContainer>;
    }
}
